function _escape(v: unknown): string {
  const s = String(v ?? "");
  return s.includes(",") || s.includes('"') || s.includes("\n")
    ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows: Record<string, unknown>[]): string {
  if (!rows?.length) return "";
  const cols = Object.keys(rows[0]);
  const lines = [
    cols.map(_escape).join(","),
    ...rows.map((r) => cols.map((c) => _escape(r[c])).join(",")),
  ];
  return lines.join("\n");
}

function _triggerDownload(content: string, filename: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCsv(rows: Record<string, unknown>[], filename = "report"): void {
  _triggerDownload(toCsv(rows), `${filename}.csv`, "text/csv");
}

export function downloadJson(rows: unknown, filename = "report"): void {
  _triggerDownload(JSON.stringify(rows, null, 2), `${filename}.json`, "application/json");
}

/**
 * POST the SQL to the backend's /download-csv endpoint, receive the generated
 * CSV file, and trigger a browser download.  The backend runs the query, caps
 * at 5,000 rows, and writes the CSV — no JSON round-trip, no client-side
 * CSV generation.
 */
export async function downloadStreamCsv(sql: string, filename: string, datasourceKey?: string | null): Promise<void> {
  const baseURL = (import.meta as unknown as { env: Record<string, string> }).env.VITE_API_URL || "/api";
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${baseURL}/my-reports/download-csv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ sql_query: sql, filename, datasource_key: datasourceKey ?? null }),
  });
  if (!res.ok) throw new Error(`CSV download failed (${res.status})`);
  const blob = await res.blob();
  _triggerDownload(await blob.text(), `${filename}.csv`, "text/csv");
}
